import React from 'react';
import { Check } from 'lucide-react';
import { Section } from './Shared';
export const ValueStack = () => {
  const items = [{
    title: '📘 Tomo 1 — El Despertar y la Limpieza',
    value: '$15.000 ARS'
  }, {
    title: '📗 Tomo 2 — El Imán y la Ingeniería',
    value: '$15.000 ARS'
  }, {
    title: '📙 Tomo 3 — La Expansión y el Sello',
    value: '$15.000 ARS'
  }, {
    title: '🎧 Bonus 1 — Meditación de Activación',
    value: '$7.000 ARS'
  }, {
    title: '📋 Bonus 2 — Script de Ventas',
    value: '$5.000 ARS'
  }];
  return <Section data-id="element-285">
      <div className="text-center mb-12" data-id="element-286">
        <h2 className="md:text-4xl font-serif font-bold mb-4 text-[24px]" data-id="element-287">
          💰 LO QUE RECIBÍS HOY
        </h2>
      </div>

      <div className="max-w-2xl mx-auto glass-panel p-8 md:p-10 rounded-3xl border-brand-pink/30 bg-white/80 shadow-lg pt-[3px] pb-[3px] pl-[20px] pr-[20px] space-y-[10px]" data-id="element-288">
        <div className="space-y-4 mb-8" data-id="element-289">
          {items.map((item, i) => <div key={i} className="flex justify-between items-center border-b border-brand-pink/10 pb-3" data-id="element-290">
              <span className="text-brand-text/90 font-medium" data-id="element-291">
                {item.title}
              </span>
              <span className="text-brand-text/50 line-through text-sm" data-id="element-292">
                {item.value}
              </span>
            </div>)}
        </div>

        <div className="border-t-2 border-brand-gold/30 pt-6 mb-8" data-id="element-293">
          <div className="flex justify-between items-center mb-2" data-id="element-294">
            <span className="text-lg font-serif font-bold text-brand-text/70" data-id="element-295">
              VALOR TOTAL:
            </span>
            <span className="text-lg font-bold text-brand-text/50 line-through" data-id="element-296">
              $57.000 ARS
            </span>
          </div>
          <div className="flex justify-between items-center bg-brand-surfaceLight/30 p-4 rounded-xl border border-brand-gold/20" data-id="element-297">
            <span className="text-xl md:text-2xl font-serif font-bold text-brand-text" data-id="element-298">
              TU INVERSIÓN HOY:
            </span>
            <span className="text-2xl md:text-3xl font-bold text-brand-gold" data-id="element-299">
              $19.990 ARS
            </span>
          </div>
        </div>

        <div className="space-y-3" data-id="element-300">
          <div className="flex items-center text-sm text-brand-text/80" data-id="element-301">
            <Check className="w-5 h-5 text-brand-green mr-3 shrink-0" data-id="element-302" />
            Acceso inmediato · PDF + MP3
          </div>
          <div className="flex items-center text-sm text-brand-text/80" data-id="element-303">
            <Check className="w-5 h-5 text-brand-green mr-3 shrink-0" data-id="element-304" />
            Sin suscripción · Tuyo para siempre
          </div>
          <div className="flex items-center text-sm text-brand-text/80" data-id="element-305">
            <Check className="w-5 h-5 text-brand-green mr-3 shrink-0" data-id="element-306" />
            Garantía de 7 días sin preguntas
          </div>
        </div>
      </div>
    </Section>;
};